/**
 * Usercentrics Consent Handler
 * https://docs.usercentrics.com/index_/cmp-v2-ui-api
 */

declare const UC_UI: {
	showSecondLayer(): void;
};

export function initUsercentricsReload(): void {
	if (typeof window === "undefined") return;

	window.addEventListener("UC_CONSENT", function (event: any) {
		if (event.detail?.consent?.fromUserAction && event.detail.consent.updatedBy === "onDenyAllServices") {
			location.reload();
		}
	});
}

export function initUsercentricsAcceptButtons(): void {
	document.querySelectorAll<HTMLButtonElement>("[data-uc-accept]").forEach((btn) => {
		btn.addEventListener("click", () => {
			if (typeof UC_UI !== "undefined") UC_UI.showSecondLayer();
		});
	});
}